import React from 'react';

const Loading = () => (
  <div className='is-size-1 has-text-centered loading'>Loading ...</div>
);

export default Loading;
